import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {fertilityApi, fertilityApiStatistics} from '../../Context/apiData';

import {getSelectedBranch, normalizeBranch, withBranchParams, withBranchPayload} from '../../utils/branchUtils';

export const getAllFertility = createAsyncThunk('fertility/getAllFertility', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.get(fertilityApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getAnalysis = createAsyncThunk('fertility/getAnalysis', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.get(fertilityApiStatistics, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getFertility = createAsyncThunk('fertility/getFertility', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.get(fertilityApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: withBranchParams(payload)
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const createFertility = createAsyncThunk('fertility/createFertility', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.post(fertilityApi, withBranchPayload(payload), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const updateFertility = createAsyncThunk('fertility/updateFertility', async payload => {
  try {
    const response = await axios.put(`${fertilityApi}${payload.id}/`, withBranchPayload(payload), {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    console.log(`error -->`, error);
    if (error.response.data.status.code === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.response.data || error.message;
  }
});

export const deleteFertility = createAsyncThunk('fertility/deleteFertility', async (payload, {rejectWithValue}) => {
  console.log('payload -->', payload);
  try {
    const response = await axios.delete(`${fertilityApi}${payload}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return {id: payload}; // Return deleted item ID for state update
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});
